(ns pfo.task.spec)

(def filter-params
  [:map {:closed true}
   [:alert-active [:maybe :boolean]]
   [:alert-enabled [:maybe :boolean]]
   [:alert-exclude [:maybe :boolean]]
   [:assigned-user-exclude [:maybe :boolean]]
   [:assigned-user-id [:maybe [:vector :int]]]
   [:category-exclude [:maybe :boolean]]
   [:category-id [:maybe [:vector :int]]]
   [:collection-id [:maybe [:vector :int]]]
   [:collection-type-exclude [:maybe :boolean]]
   [:collection-type-id [:maybe [:vector :int]]]
   [:complete [:maybe :boolean]]
   [:completed-from [:maybe :string]]
   [:completed-to [:maybe :string]]
   [:dropbox-sign [:maybe :boolean]]
   [:dropbox-sign-pending [:maybe :boolean]]
   [:due-exclude [:maybe :boolean]]
   [:e-boir [:maybe :boolean]]
   [:e-boir-failed [:maybe :boolean]]
   [:e-boir-not-started [:maybe :boolean]]
   [:e-boir-pending [:maybe :boolean]]
   [:e-boir-rejected [:maybe :boolean]]
   [:future [:maybe :boolean]]
   [:include-subcollections [:maybe :boolean]]
   [:label-ids :any #_[:maybe :string]] ;; TODO
   [:late [:maybe :boolean]]
   [:order [:maybe :string]]
   [:page [:maybe :int]]
   [:period-exclude [:maybe :boolean]]
   [:priority [:maybe [:vector :int]]]
   [:priority-exclude [:maybe :boolean]]
   [:quarter [:maybe :int]]
   [:report [:maybe :boolean]]
   [:report-current-period-only [:maybe :boolean]]
   [:report-next-only [:maybe :boolean]]
   [:report-selected-step-index [:maybe :int]]
   [:report-template-group-id [:maybe :int]]
   [:report-template-group-subscriber-id [:maybe :int]]
   [:rule-exclude [:maybe :boolean]]
   [:rule-id [:maybe [:vector :int]]]
   [:signature [:maybe :boolean]]
   [:signatures [:maybe :boolean]]
   [:signatures-dropbox-sign [:maybe :boolean]]
   [:signatures-other [:maybe :boolean]]
   [:signatures-pending [:maybe :boolean]]
   [:signatures-complete [:maybe :boolean]]
   [:step-number [:maybe :int]]
   [:steps [:maybe :string]]
   [:task-type [:maybe :string]]
   [:today [:maybe :boolean]]
   [:year [:maybe :int]]])
